import React from 'react';

const tabs = [
  { id: 'home',  label: 'Головна',
    icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M3 11.5L12 3l9 8.5V21a1 1 0 01-1 1H5a1 1 0 01-1-1v-9.5z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/><rect x="9" y="14" width="6" height="8" rx="0.5" stroke="currentColor" strokeWidth="1.8"/></svg> },
  { id: 'menu',  label: 'Меню',
    icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="8" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.8"/><rect x="13" y="3" width="8" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.8"/><rect x="3" y="13" width="8" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.8"/><rect x="13" y="13" width="8" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.8"/></svg> },
  { id: 'lanch', label: 'Ланч',
    icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><line x1="4" y1="7" x2="20" y2="7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><line x1="4" y1="12" x2="16" y2="12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><line x1="4" y1="17" x2="20" y2="17" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg> },
  { id: 'bar',   label: 'Бар',
    icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="1.8"/><circle cx="12" cy="12" r="3.5" fill="currentColor" opacity="0.6"/></svg> },
];

export default function BottomNav({ activeTab, onTabChange }) {
  return (
    <nav style={{
      display: 'flex', background: '#fff',
      borderTop: '1px solid var(--border)',
      paddingBottom: 'env(safe-area-inset-bottom)',
      flexShrink: 0,
    }}>
      {tabs.map(tab => {
        const active = activeTab === tab.id;
        return (
          <button key={tab.id} onClick={() => onTabChange(tab.id)} style={{
            flex: 1, display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center',
            gap: 3, padding: '10px 0 8px',
            border: 'none', background: 'transparent',
            color: active ? 'var(--ink)' : 'var(--stone)',
            position: 'relative', transition: 'color 0.15s', cursor: 'pointer',
          }}>
            {active && (
              <div style={{
                position: 'absolute', top: 0, left: '50%',
                transform: 'translateX(-50%)',
                width: 28, height: 2.5,
                background: 'var(--highlight)',
                borderRadius: '0 0 3px 3px',
              }} />
            )}
            {tab.icon}
            <span style={{ fontSize: 10, fontWeight: active ? 500 : 400 }}>
              {tab.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
